export default __webpack_public_path__ + "static/media/defaultMaleProfile.450c7b78.jpg";